// extracted by mini-css-extract-plugin
export default {"SectionTitle":"meinian-order-detail_SectionTitle__r+79l","SectionSubTitle":"meinian-order-detail_SectionSubTitle__9JVGg","Toolbar":"meinian-order-detail_Toolbar__2Rwwj"};